module.exports = __webpack_public_path__ + "img/office-lighting.f654491.jpg";